import UiDetail from "./UiDetail";
import { EnumMiezzFormItemType, MiezzFormItem } from "@/models/MiezzForm";
import { EnumPipe } from "@/models/EnumPipe";
import UiGroup from "./UiGroup";

/**
 * 币制详细
 * @description 自动生成的代码,请勿修改
 */
export default class DtoDetailParamCurrencySystem extends UiDetail<string> {
    constructor() {
        //无参构造函数
        super()
    }

    [proName: string]: any;
    /**
     * 中文名称
     */
    NameZh?: string;
    /**
     * 英文名称
     */
    NameEn?: string;
    /**
     * 代码
     */
    Code?: string;
    /**
     * 全名
     */
    FullName?: string;
}

/**
 * 币制详细-表单校验
 */
export const DtoDetailParamCurrencySystemRules = {
}

/**
 * 币制详细-设置项
 */
export const DtoDetailParamCurrencySystemMiezzDetailItems: MiezzFormItem[] = [
  {
    Prop: "NameZh",
    Label: "中文名称",
    Type: EnumMiezzFormItemType.Text,
  },
  {
    Prop: "NameEn",
    Label: "英文名称",
    Type: EnumMiezzFormItemType.Text,
  },
  {
    Prop: "Code",
    Label: "代码",
    Type: EnumMiezzFormItemType.Text,
  },
  {
    Prop: "FullName",
    Label: "全名",
    Type: EnumMiezzFormItemType.Text,
  },
]
